import React, { Component } from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { ChromePicker } from 'react-color'
import i18n from '../i18n.json'

class LogoEditor extends Component {

  fromPropsToState(props) {
    let { text, brandTypeface, params, colorPalette, layoutProcedure, sloganText, sloganTypeface, asset } = this.props
    let { availableTypefaces, availableColorPalettes, availableIcons } = this.props
    let iconsCounter = 0
    if (asset) {
      if (asset.id) iconsCounter = availableIcons.map(x => x.id).indexOf(asset.id.toString())
    }
    if (colorPalette) {
      if (colorPalette.colored && !colorPalette.original) {
        colorPalette.original = colorPalette.colored.slice(0)
      }
    }
    this.state = {
      text, brandTypeface, params, colorPalette, layoutProcedure, sloganText, sloganTypeface, asset,
      uid: props.uid,
      typefacesCounter: availableTypefaces.map(x => x.uid).indexOf(brandTypeface.uid),
      typefacesSloganCounter: availableTypefaces.map(x => x.uid).indexOf(sloganTypeface.uid),
      iconsCounter: iconsCounter,
      colorsCounter: availableColorPalettes.map(x => x.uid).indexOf(colorPalette.uid),
      displayEditor: false,
      displayColorPickPrimary: false,
      displayColorPickSecondary: false,
    }
  }

  constructor(props) {
    super(props)
    this.fromPropsToState(this.props)
  }

  onMoreColor(evt) {
    evt.preventDefault()
    let { availableColorPalettes } = this.props
    if (availableColorPalettes.length <= 0) return
    let colorsCounter = this.state.colorsCounter + 1
    if (colorsCounter >= availableColorPalettes.length) colorsCounter = 0
    let colorPalette = availableColorPalettes[colorsCounter]
    if (colorPalette.colored && !colorPalette.original) {
      colorPalette.original = colorPalette.colored.slice(0)
    }
    this.setState({ colorPalette, colorsCounter }, () => {
      this.props.onEditedParams({ colorPalette: colorPalette})
    })
  }
  onLessColor(evt) {
    evt.preventDefault()
    let { availableColorPalettes } = this.props
    if (availableColorPalettes.length <= 0) return
    let colorsCounter = this.state.colorsCounter - 1
    if (colorsCounter <= 0 ) colorsCounter = availableColorPalettes.length - 1
    let colorPalette = availableColorPalettes[colorsCounter]
    if (colorPalette.colored && !colorPalette.original) {
      colorPalette.original = colorPalette.colored.slice(0)
    }
    this.setState({ colorPalette, colorsCounter }, () => {
      this.props.onEditedParams({ colorPalette: colorPalette})
    })
  }

  onMoreTypefaceForBrandname(evt) {
    evt.preventDefault()
    let { availableTypefaces } = this.props
    if (availableTypefaces.length <= 0) return
    let typefacesCounter = this.state.typefacesCounter + 1
    if (typefacesCounter >= availableTypefaces.length) typefacesCounter = 0
    let brandTypeface = availableTypefaces[typefacesCounter]

    this.setState({ brandTypeface, typefacesCounter }, () => {
      this.props.onEditedParams({ brandTypeface: brandTypeface})
    })
  }
  onLessTypefaceForBrandname(evt) {
    evt.preventDefault()
    let { availableTypefaces } = this.props
    if (availableTypefaces.length <= 0) return
    let typefacesCounter = this.state.typefacesCounter - 1
    if (typefacesCounter <= 0 ) typefacesCounter = availableTypefaces.length - 1
    let brandTypeface = availableTypefaces[typefacesCounter]
    this.setState({ brandTypeface, typefacesCounter }, () => {
      this.props.onEditedParams({ brandTypeface: brandTypeface})
    })
  }

  onMoreTypefaceForSlogan(evt) {
    evt.preventDefault()
    let { availableTypefaces } = this.props
    if (availableTypefaces.length <= 0) return
    let typefacesSloganCounter = this.state.typefacesSloganCounter + 1
    if (typefacesSloganCounter >= availableTypefaces.length) typefacesSloganCounter = 0
    let sloganTypeface = availableTypefaces[typefacesSloganCounter]

    this.setState({ sloganTypeface, typefacesSloganCounter }, () => {
      this.props.onEditedParams({ sloganTypeface: sloganTypeface})
    })
  }
  onLessTypefaceForSlogan(evt) {
    evt.preventDefault()
    let { availableTypefaces } = this.props
    if (availableTypefaces.length <= 0) return
    let typefacesSloganCounter = this.state.typefacesSloganCounter - 1
    if (typefacesSloganCounter <= 0 ) typefacesSloganCounter = availableTypefaces.length - 1
    let sloganTypeface = availableTypefaces[typefacesSloganCounter]
    this.setState({ sloganTypeface, typefacesSloganCounter }, () => {
      this.props.onEditedParams({ sloganTypeface: sloganTypeface})
    })
  }
  onMoreIcon(evt) {
    evt.preventDefault()
    let { availableIcons } = this.props
    if (availableIcons.length <= 0) return
    let iconsCounter = this.state.iconsCounter + 1
    if (iconsCounter >= availableIcons.length) iconsCounter = 0
    let asset = availableIcons[iconsCounter]
    this.setState({ asset, iconsCounter }, () => {
      this.props.onEditedParams({ asset: asset })
    })
  }
  onLessIcon(evt) {
    evt.preventDefault()
    let { availableIcons } = this.props
    if (availableIcons.length <= 0) return
    let iconsCounter = this.state.iconsCounter - 1
    if (iconsCounter <= 0 ) iconsCounter = availableIcons.length - 1
    let asset = availableIcons[iconsCounter]
    this.setState({ asset, iconsCounter }, () => {
      this.props.onEditedParams({ asset: asset})
    })
  }

  sameBrandTypeface(evt) {
    evt.preventDefault()
    this.setState({ sloganTypeface: this.state.brandTypeface }, () => {
      this.props.onEditedParams({ sloganTypeface: this.state.brandTypeface })
    })
  }

  sameSloganTypeface(evt) {
    evt.preventDefault()
    this.setState({ brandTypeface: this.state.sloganTypeface }, () => {
      this.props.onEditedParams({ brandTypeface: this.state.sloganTypeface })
    })
  }

  changeGradient(evt) {
    evt.preventDefault()
    let params = this.state.params
    params.gradient = (params.gradient) ? false : true
    this.setState({ params }, () => {
      this.props.onEditedParams({ params: params })
    })
  }

  changeBrandCase(evt) {
    evt.preventDefault()
    let params = this.state.params
    params.capitalizeBrand = (params.capitalizeBrand) ? false : true
    this.setState({ params }, () => {
      this.props.onEditedParams({ params: params })
    })
  }

  changeSloganCase(evt) {
    evt.preventDefault()
    let params = this.state.params
    params.capitalizeSlogan = (params.capitalizeSlogan) ? false : true
    this.setState({ params }, () => {
      this.props.onEditedParams({ params: params })
    })
  }

  changeToOriginal(evt) {
    evt.preventDefault()
    let colorPalette = this.state.colorPalette
    if (colorPalette.original) {
      colorPalette.colored = colorPalette.original.slice(0)
    }
    this.setState({ colorPalette }, () => {
      this.props.onEditedParams({ colorPalette: colorPalette })
    })
  }

  changeMono(evt) {
    evt.preventDefault()
    let colorPalette = this.state.colorPalette
    colorPalette.colored[1] = colorPalette.colored[0]
    this.setState({ colorPalette }, () => {
      this.props.onEditedParams({ colorPalette: colorPalette })
    })
  }

  handleColorPickPrimary = () => {
    this.setState({ displayColorPickPrimary: !this.state.displayColorPickPrimary })
  }

  handleCloseColorPickPrimary = () => {
    this.setState({ displayColorPickPrimary: false })
  }

  handleChangeColorPickPrimary = (color) => {
    let colorPalette = this.state.colorPalette
    colorPalette.colored[0] = color.hex
    this.setState({ colorPalette }, () => {
      this.props.onEditedParams({ colorPalette: colorPalette })
    })
  }

  handleColorPickSecondary = () => {
    this.setState({ displayColorPickSecondary: !this.state.displayColorPickSecondary })
  }

  handleCloseColorPickSecondary = () => {
    this.setState({ displayColorPickSecondary: false })
  }

  handleChangeColorPickSecondary = (color) => {
    let colorPalette = this.state.colorPalette
    colorPalette.colored[1] = color.hex
    this.setState({ colorPalette }, () => {
      this.props.onEditedParams({ colorPalette: colorPalette })
    })
  }

  handleColorPickBackground = () => {
    this.setState({ displayColorPickBackground: !this.state.displayColorPickBackground })
  }

  handleCloseColorPickBackground = () => {
    this.setState({ displayColorPickBackground: false })
  }

  handleChangeColorPickBackground = (color) => {
    let colorPalette = this.state.colorPalette
    colorPalette.colorBackground = color.hex
    this.setState({ colorPalette }, () => {
      this.props.onEditedParams({ colorPalette: colorPalette })
    })
  }

  render() {
    if (this.props.uid !== this.state.uid) this.fromPropsToState(this.props)

    let { selectedLanguage } = this.props
    let currentIcon = null
    if (this.state.asset) currentIcon = this.state.asset.preview_url_42
    let colorPaletteEditor = this.state.colorPalette.colored.slice(0)
    let colorPaletteBackground = "#fff"
    if (this.state.colorPalette.colorBackground) colorPaletteBackground = this.state.colorPalette.colorBackground

    const popover = {
      position: 'absolute',
      zIndex: '2',
      top: '-100%'
    }
    const cover = {
      position: 'absolute',
      top: '-1000%',
      height: '2000%',
      left: '-1000%',
      width: '2000%'
    }

    // logo-editor-modal
    return (
    <div className="editor">
      <h1 className="editor-cta">{ i18n[selectedLanguage]['editor-title'] }</h1>

      <div className="logo-editor">
        <div className="logo-editor-item">
          <div className="mini-colorpalette-head">
            <a onClick={ this.onLessColor.bind(this) }>
              <FontAwesomeIcon icon={["fa", "chevron-circle-left"]} className="logo-editor-arrows" />
            </a>
            <h1>{ i18n[selectedLanguage]['editor-colors-title'] }</h1>
            <a onClick={ this.onMoreColor.bind(this) }>
              <FontAwesomeIcon icon={["fa", "chevron-circle-right"]} className="logo-editor-arrows" />
            </a>
          </div>

          <div className="mini-colorpalette">
              <div>
                <div className="mini-colorpalette-item" onClick={ this.handleColorPickPrimary.bind(this) } style={{ backgroundColor: colorPaletteEditor[0] }}></div>
                {
                  this.state.displayColorPickPrimary ?
                  <div style={ popover }>
                    <div style={ cover } onClick={ this.handleCloseColorPickPrimary.bind(this) }/>
                    <ChromePicker color={ colorPaletteEditor[0] } onChange={ this.handleChangeColorPickPrimary.bind(this) } />
                  </div>
                  : null
                }
                <p style={{ textAlign: 'center', fontSize: "7pt" }}>{ i18n[selectedLanguage]['editor-primary'] }</p>
              </div>
              <div>
                <div className="mini-colorpalette-item" onClick={ this.handleColorPickSecondary.bind(this) } style={{ backgroundColor: colorPaletteEditor[1] }}></div>
                {
                  this.state.displayColorPickSecondary ?
                  <div style={ popover }>
                    <div style={ cover } onClick={ this.handleCloseColorPickSecondary.bind(this) }/>
                    <ChromePicker color={ colorPaletteEditor[1] } onChange={ this.handleChangeColorPickSecondary.bind(this) } />
                  </div>
                  : null
                }
                <p style={{ textAlign: 'center', fontSize: "7pt" }}>{ i18n[selectedLanguage]['editor-secondary'] }</p>
              </div>
              <div>
                <div className="mini-colorpalette-item" onClick={ this.handleColorPickBackground.bind(this) } style={{ backgroundColor: colorPaletteBackground }}></div>
                {
                  this.state.displayColorPickBackground ?
                  <div style={ popover }>
                    <div style={ cover } onClick={ this.handleCloseColorPickBackground.bind(this) }/>
                    <ChromePicker color={ colorPaletteBackground } onChange={ this.handleChangeColorPickBackground.bind(this) } />
                  </div>
                  : null
                }
                <p style={{ textAlign: 'center', fontSize: "7pt" }}>{ i18n[selectedLanguage]['editor-background'] }</p>
              </div>
          </div>

          <br/>
          <p style={{ textAlign: 'center' }}>{ i18n[selectedLanguage]['editor-colors-description'] }</p>

          <div className="mini-colorpalette mini-ui">
            <a onClick={ this.changeMono.bind(this) }>
              <FontAwesomeIcon icon={["fa", "adjust"]} className="logo-editor-icons" /><br />
              { i18n[selectedLanguage]['editor-colors-mono'] }
            </a>
            <a onClick={ this.changeToOriginal.bind(this) }>
              <FontAwesomeIcon icon={["fa", "undo"]} className="logo-editor-icons" /><br />
              { i18n[selectedLanguage]['editor-colors-reset'] }
            </a>
            <a onClick={ this.changeGradient.bind(this) }>
              <FontAwesomeIcon icon={["fa", "barcode"]} className="logo-editor-icons" /><br />
              { i18n[selectedLanguage]['editor-colors-gradient'] }
            </a>
          </div>
        </div>

        { this.state.asset
          ?
          <div className="logo-editor-item">
            <div className="mini-colorpalette-head">
             <a onClick={ this.onLessIcon.bind(this) }>
               <FontAwesomeIcon icon={["fa", "chevron-circle-left"]} className="logo-editor-arrows" />
             </a>
              <h1>{ i18n[selectedLanguage]['editor-icon-title'] }</h1>
              <a onClick={ this.onMoreIcon.bind(this) }>
                <FontAwesomeIcon icon={["fa", "chevron-circle-right"]} className="logo-editor-arrows" />
                <i className="fa fa-arrow-right"></i>
              </a>
            </div>

             <div className="mini-colorpalette">
              <div className="mini-selector-item">
                <img src={ currentIcon } alt="Logo Icon" />
              </div>
            </div>
          </div>
          : null
        }

        <div className="logo-editor-item">
          <div className="mini-colorpalette-head">
           <a onClick={ this.onLessTypefaceForBrandname.bind(this) }>
               <FontAwesomeIcon icon={["fa", "chevron-circle-left"]} className="logo-editor-arrows" />
           </a>
            <h1>{ i18n[selectedLanguage]['editor-brand-title'] }</h1>
            <a onClick={ this.onMoreTypefaceForBrandname.bind(this) }>
                <FontAwesomeIcon icon={["fa", "chevron-circle-right"]} className="logo-editor-arrows" />
            </a>
          </div>

           { /**
             <div className="mini-colorpalette">
              <div className="mini-selector-item">
                <b>{ this.state.brandTypeface.name }</b>
              </div>
            </div>
          **/ }
          { this.state.sloganText
            ?
            <div className="mini-colorpalette mini-ui">
              <a onClick={ this.sameSloganTypeface.bind(this) }>
                <FontAwesomeIcon icon={["fas", "chevron-circle-right"]} className="logo-editor-icons" /><br />
                { i18n[selectedLanguage]['editor-brand-same'] }
              </a>
              <a onClick={ this.changeBrandCase.bind(this) }>
                <FontAwesomeIcon icon={["fas", "text-height"]} className="logo-editor-icons" /><br />
                { i18n[selectedLanguage]['editor-brand-case'] }
              </a>
            </div>
            :
            <div className="mini-colorpalette mini-ui">
              <a onClick={ this.changeBrandCase.bind(this) }>
                <FontAwesomeIcon icon={["fas", "text-height"]} className="logo-editor-icons" /><br />
                { i18n[selectedLanguage]['editor-brand-case'] }
              </a>
            </div>
          }
        </div>

        { this.state.sloganText
          ?
          <div className="logo-editor-item">
            <div className="mini-colorpalette-head">
              <a onClick={ this.onLessTypefaceForSlogan.bind(this) }>
                <FontAwesomeIcon icon={["fa", "chevron-circle-left"]} className="logo-editor-arrows" />
              </a>
              <h1>{ i18n[selectedLanguage]['editor-slogan-title'] }</h1>
              <a onClick={ this.onMoreTypefaceForSlogan.bind(this) }>
                <FontAwesomeIcon icon={["fa", "chevron-circle-right"]} className="logo-editor-arrows" />
              </a>
            </div>

            { /**
            <div className="mini-colorpalette">
              <div className="mini-selector-item">
                <b>{ this.state.sloganTypeface.name }</b>
              </div>
            </div>
            **/ }
            <div className="mini-colorpalette mini-ui">
              <a onClick={ this.sameBrandTypeface.bind(this) }>
                <FontAwesomeIcon icon={["fas", "chevron-circle-left"]} className="logo-editor-icons" /><br />
                { i18n[selectedLanguage]['editor-slogan-same'] }
              </a>
              <a onClick={ this.changeSloganCase.bind(this) }>
                <FontAwesomeIcon icon={["fas", "text-height"]} className="logo-editor-icons" /><br />
                { i18n[selectedLanguage]['editor-slogan-case'] }
              </a>
            </div>
          </div>

          : null
        }
      </div>
    </div>
    )
  }
}

export default LogoEditor



// WEBPACK FOOTER //
// ./src/components/LogoEditor.js